function handleFormToggle() {
  const toggleButtons = document.querySelectorAll('[data-action="toggleForm"]');
  const applicationForm = document.getElementById("application-form");
  const applicationDescription = document.getElementById(
    "application-description",
  );
  const gForm = document.querySelector(
    ".gform_wrapper form",
  ) as HTMLFormElement | null;

  if (gForm && !gForm.action.includes("show=form")) {
    gForm.action += "?show=form";
  }

  const mainContent = document.getElementById("main-content");

  const gFormsErrors = document.querySelector(".gform_validation_errors");

  if (gFormsErrors && mainContent) {
    mainContent.scrollIntoView();
  }

  const urlParams = new URLSearchParams(window.location.search);
  const show = urlParams.get("show");

  if (show === "form") {
    toggleState();
  }

  toggleButtons?.forEach((button) => {
    button.addEventListener("click", () => {
      toggleState();
      mainContent?.scrollIntoView();

      const urlParams = new URLSearchParams(window.location.search);
      const show = urlParams.get("show");

      const url = new URL(window.location.toString());
      if (show === "form") {
        url.searchParams.delete("show");
      } else {
        url.searchParams.set("show", "form");
      }

      history.pushState({}, "", url);
    });
  });

  function toggleState() {
    const newLabel = (toggleButtons?.[0] as HTMLButtonElement)?.dataset
      .toggleLabel;
    const currentLabel = toggleButtons?.[0]?.textContent;
    if (newLabel && currentLabel) {
      ([...toggleButtons] as HTMLButtonElement[]).forEach((button) => {
        button.textContent = newLabel;
        button.dataset.toggleLabel = currentLabel;
      });
    }

    applicationForm?.classList.toggle("hidden");
    applicationDescription?.classList.toggle("hidden");
  }
}

handleFormToggle();
